import { PressDetailPageWrapperLazy } from './pressDetailPageWrapperLazy';

const props = [];

export const PressDetailPageWrapperDirective = reactDirective => reactDirective(PressDetailPageWrapperLazy, props);
PressDetailPageWrapperDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('pressDetailPageWrapper', PressDetailPageWrapperDirective);
